import $ from 'jquery';
import debounce from 'lodash-es/debounce';
import vue from './vue';
import { calculateIngressLengths } from './swiper';
import readingListButton from './reading-list-button';

const debounceTime = 1000;
const oldestArticlePublicationYear = 2000; //Consider getting from API later

export default function init(el) {
  if (!el) {
    return;
  }
  return createVue(el);
}

async function createVue(container) {
  const $mozaik = $(container);
  const id = container.id;

  const Vue = await vue();
  const app = new Vue({
      el: '#' + id,
      data: {
        loading: false,
        posts_html: "",
        post_type: "",
        post_types: [],
        search_term: "",
        count: 0,
        posts_per_page: 10,
        page_number: 0,
        previous_page: 0,
        page_count: 0,
        requests: [],
        published: "",
        topic: "",
        hierarchies: [],
        terms: [],
        selected_hierarchies: [],
        selected_years: [],
        selected_post_types: [],
        selected_terms: [],
        translations: null,
        show_filters: true,
        show_events_in: "",
        years: [],
        support_url_params: true,
        taxonomies: ['post_tag', 'category', 'event_types', 'article_types', 'blog_types', 'project_types', 'case_types', 'environment_effect'],

        /* attributes needed only for mozaik-component */
        mozaik_id: null,
        predefined_terms: [],
        predefined_filters: null,
        selected_terms_in_main_filter: [],
        selected_terms_in_secondary_filter: [],
        term_relation: 'OR',
        pagination_type: 'paging',
        order_by: 'date',
      },

      beforeMount: function() {

          this.hierarchies = JSON.parse($("#hierarchies").html());
          this.terms = JSON.parse($("#terms").html());
          this.post_types = JSON.parse($("#post-types").html());
          this.posts_per_page = $mozaik.attr("data-posts-per-page");

          this.initYears();

          this.parseSettings(); //used in mozaik component
          if (this.support_url_params) {
              this.parseUrlParameters(); //used in archive page
          }

          this.readMozaikState();

          this.selected_terms = this.selected_terms_in_main_filter.concat(this.selected_terms_in_secondary_filter);

          this.fetchPosts();
      },

      updated: function () {
        this.$nextTick(function () {
            calculateIngressLengths(container);
        });
      },

      methods: {
          initYears: function() {
              var currentYear = new Date().getFullYear();

              var years = [];
              for (var i = oldestArticlePublicationYear; i <= currentYear; i++) {
                  years.push(i);
              }

              this.years = years.reverse();
          },

          getCurrentLanguage: function() {
              if (window.location.pathname.indexOf('/en/') >= 0) {
                  return "en";
              } else if (window.location.pathname.indexOf('/sv/') >= 0) {
                  return "sv";
              } else {
                  return "fi";
              }
          },

          fetchPosts: function() {
              this.startLoading();
              $.get(this.generateFetchPostsUrl(), {
                  beforeSend: (xhr) => {
                      this.abortPreviousRequests();
                      this.requests.push(xhr); //add new request to queue to be able to abort it later
                  },
              }).then((response) => {
                  this.posts_html = response.posts_html;
                  this.count = response.post_count;
                  this.page_count = response.page_count;

                  this.stopLoading();

                  if (this.pagination_type === "paging") {
                      $('html, body').animate({
                          scrollTop: $(".mozaik-js").offset().top - 200,
                      }, 300);
                  }

                  this.loading = false;
                  setTimeout(() => { readingListButton() }, 0);
                  
              }, () => {
                  //if error happens, go back to old page
                  this.page_number = this.previous_page;
                  this.stopLoading();
              });

          },


          fetchPostsLoadMore: function() {
              this.startLoading();
              $.get(this.generateFetchPostsUrl(), {
                  beforeSend: (xhr) => {
                      this.abortPreviousRequests();
                      this.requests.push(xhr); //add new request to queue to be able to abort it later
                  },
              }).then((response) => {
                  this.posts_html += response.posts_html;
                  this.count = response.post_count;
                  this.page_count = response.page_count;
                  this.stopLoading();

                  this.loading = false;
                  setTimeout(() => { readingListButton() }, 0);

              }, () => {
                  //if error happens, go back to old page
                  this.page_number = this.previous_page;
                  this.stopLoading();
              });

          },


          debouncedFetchPosts: debounce(function() {
              this.fetchPosts();
          }, debounceTime),


          loadMore: function() {
              this.startLoading();
              this.previous_page = this.page_number;
              this.page_number = this.page_number + 1;
              this.fetchPostsLoadMore();
          },

          abortPreviousRequests: function() {
              let request;
              while (request = this.requests.shift()) {
                request.abort();
              }
          },


          parseSettings: function() {
              if ($mozaik.attr("data-support-url-params") === "false") {
                  this.support_url_params = false;
              }

              //parse post types
              var post_types = JSON.parse($mozaik.attr("data-post-types"));

              if (!empty(post_types)) {
                  this.selected_post_types = this.findPostTypesForPostNames(post_types);
              }

              //parse topics, themes and projects
              var hierarchies = [];

              var topics = JSON.parse($mozaik.attr("data-topics"));
              if (!empty(topics)) {
                  hierarchies = hierarchies.concat(topics);
              }

              var themes = JSON.parse($mozaik.attr("data-themes"));
              if (!empty(themes)) {
                  hierarchies = hierarchies.concat(themes);
              }

              var projects = JSON.parse($mozaik.attr("data-projects"));
              if (!empty(projects)) {
                  hierarchies = hierarchies.concat(projects);
              }

              var predefinedFilters = JSON.parse($mozaik.attr("data-predefined-filters"));
              if (!empty(predefinedFilters) && (predefinedFilters?.main?.taxonomy || predefinedFilters?.secondary?.taxonomy)) {
                  this.predefined_filters = predefinedFilters;
              }

              var showEventsIn = $mozaik.attr("data-show-events-in");
              if (!empty(showEventsIn) && showEventsIn !== 'all') {
                  this.show_events_in = showEventsIn;
              }

              var termRelation = $mozaik.attr("data-term-relation");
              if (!empty(termRelation)) {
                  this.term_relation = termRelation;
              }

              var paginationType = $mozaik.attr("data-pagination-type");
              if (!empty(paginationType)) {
                  this.pagination_type = paginationType;
              }

              var orderBy = $mozaik.attr("data-order-by");
              if (!empty(orderBy)) {
                  this.order_by = orderBy;
              }

              this.mozaik_id = $mozaik.attr("id");

              this.selected_hierarchies = this.findHierarchiesByIds(hierarchies);

              //parse terms
              var terms = [];

              var taxonomies = JSON.parse($mozaik.attr('data-taxonomies'));

              if (!empty(taxonomies)) {

                  for (var i = 0; i < this.taxonomies.length; i++) {
                      var taxonomy = this.taxonomies[i];
                      if (typeof(taxonomies[taxonomy]) !== 'undefined') {
                          var these_terms = taxonomies[taxonomy];
                          terms = terms.concat(these_terms);
                      }
                  }

                  this.predefined_terms = this.findTermsByIds(terms);

              }

          },


          findPostTypesForPostNames: function(post_names) {
              var finded_post_types = [];
              for (var i = 0; i < this.post_types.length; i++) {
                  if (post_names.indexOf(this.post_types[i].name) > -1) {
                      finded_post_types.push(this.post_types[i]);
                  }
              }
              return finded_post_types;
          },


          findHierarchiesByIds: function(hierarchy_ids) {
              var finded_hierarchies = [];

              //join projects, topics and themes
              var all_hierarchies = this.hierarchies.topics.concat(this.hierarchies.projects).concat(this.hierarchies.themes);

              for (var i = 0; i < all_hierarchies.length; i++) {
                  if (hierarchy_ids.indexOf(parseInt(all_hierarchies[i].ID)) > -1) {
                      finded_hierarchies.push(all_hierarchies[i]);
                  }
              }
              return finded_hierarchies;
          },


          findTermsByIds: function(term_ids) {
              var finded_terms = [];
              var all_terms = this.getAllTerms();
              for (var i = 0; i < all_terms.length; i++) {
                  if (typeof(all_terms[i]) !== 'undefined' &&
                      typeof(all_terms[i].term_id) !== 'undefined' &&
                      term_ids.indexOf(parseInt(all_terms[i].term_id)) > -1) {
                      finded_terms.push(all_terms[i]);
                  }
              }

              return finded_terms;
          },

          getAllTerms: function() {
              var terms = [];
              for (var i = 0; i < this.taxonomies.length; i++) {
                  terms = terms.concat(this.terms[this.taxonomies[i]]);
              }
              return terms;
          },


          isActive: function(pageNumber) {
              if (this.page_number === pageNumber) return true;
              return false;
          },

          hasNextPage: function() {
              if (this.page_number < (this.page_count - 1)) return true;
              return false;
          },

          postHasImage: function(post) {
              if (post.portrait_image === false) return false;
              return true;
          },

          getSelectedTermsByTaxonomy: function(taxonomy) {
              return this.selected_terms.filter(function(term) {
                  return term.taxonomy === taxonomy;
              }).map(function(term) {
                  return term.term_id;
              });
          },

          generateCurrentPageUrl: function() {
              return "?" + this.generateUrlParameters();
          },

          generateFetchPostsUrl: function() {
              return '/wp/wp-admin/admin-ajax.php?action=get_posts&' + this.generateUrlParameters() + 'lang=' + this.getCurrentLanguage();
          },

          generateUrlParameters: function() {
              var post_types = this.selected_post_types.map(function(x) {
                  return x.name;
              });

              post_types = post_types.join();

              console.log(this.selected_hierarchies);

              var projects = this.selected_hierarchies.filter(function(post) {
                  return post.post_type === "sitra_projects";
              }).map(function(post) {
                  return post.ID;
              });

              var themes = this.selected_hierarchies.filter(function(post) {
                  return post.post_type === "sitra_themes";
              }).map(function(post) {
                  return post.ID;
              });

              var topics = this.selected_hierarchies.filter(function(post) {
                  return post.post_type === "sitra_topics";
              }).map(function(post) {
                  return post.ID;
              });

              //generate url for terms in each taxonomy
              var term_part_of_url = "";
              for (var i = 0; i < this.taxonomies.length; i++) {
                  term_part_of_url += "_" + this.taxonomies[i] + "=";
                  term_part_of_url += encodeURIComponent(this.getSelectedTermsByTaxonomy(this.taxonomies[i]).join());
                  term_part_of_url += "&";
              }

              var predefined_terms = this.predefined_terms.map(function(x) {
                  return x.term_id;
              });

              term_part_of_url += "term_relation=" + this.term_relation + "&";

              return 'post_types=' + encodeURIComponent(post_types) +
                  '&page_number=' + encodeURIComponent(this.page_number) +
                  '&posts_per_page=' + encodeURIComponent(this.posts_per_page) +
                  '&search_term=' + encodeURIComponent(this.search_term) +
                  '&publication_years=' + encodeURIComponent(this.selected_years.join()) +
                  '&_topics=' + encodeURIComponent(topics.join()) +
                  '&_projects=' + encodeURIComponent(projects.join()) +
                  '&_themes=' + encodeURIComponent(themes.join()) +
                  '&show_events_in=' + this.show_events_in +
                  '&_predefined_terms=' + encodeURIComponent(predefined_terms.join()) +
                  '&order_by=' + this.order_by +
                  '&' + term_part_of_url;
          },

          startLoading: function() {
              $(".archive-page-grid").css("opacity", 0);
              $(".loading-spinner").css({"opacity": 1, "display": "block"});
              this.loading = true;
          },

          stopLoading: function() {
              $(".archive-page-grid").css("opacity", 1);
              $(".loading-spinner").css({"opacity": 0, "display": "none"});
          },

          translate: function(key) {
              if (this.translations == null) this.initTranslations();
              return this.translations[key];
          },

          initTranslations: function() {
              this.translations = JSON.parse($("#vue-js-translations").html());
          },


          /* Mozaik-component related methods */
          selectPredefinedFilter: function(filter_name, term) {
              this.selected_terms = [];

              if (!empty(term)) {

                  if (filter_name === 'main') {
                      this.selected_terms_in_main_filter = [];
                      this.selected_terms_in_main_filter.push(term);
                  } else if (filter_name === 'secondary') {
                      this.selected_terms_in_secondary_filter = [];
                      this.selected_terms_in_secondary_filter.push(term);
                  }

              } else {

                  if (filter_name === 'main') {
                      this.selected_terms_in_main_filter = [];
                  } else if (filter_name === 'secondary') {
                      this.selected_terms_in_secondary_filter = [];
                  }
              }

              // save selected filters
              this.saveMozaikState();

              this.selected_terms = this.selected_terms_in_main_filter.concat(this.selected_terms_in_secondary_filter);

              this.page_number = 0;
              this.fetchPosts();
          },

          predefinedFilterIsActive: function(filter_name, term) {

              if (filter_name === 'main' && empty(term) && this.selected_terms_in_main_filter.length === 0) {
                  return true;
              }

              if (filter_name === 'secondary' && empty(term) && this.selected_terms_in_secondary_filter.length === 0) {
                  return true;
              }

              if (filter_name === 'main' && arrayHasTerm(this.selected_terms_in_main_filter, term)) {
                  return true;
              }

              if (filter_name === 'secondary' && arrayHasTerm(this.selected_terms_in_secondary_filter, term)) {
                  return true;
              }

              return false;
          },


          saveMozaikState: function() {
              var mozaikState = {
                  selected_terms_in_main_filter: this.selected_terms_in_main_filter,
                  selected_terms_in_secondary_filter: this.selected_terms_in_secondary_filter,
              };

              try {
                  localStorage.setItem(this.mozaik_id + "-state", JSON.stringify(mozaikState));
              } catch(err) {
                  //LocalStorage not available, do nothing...
              }
          },


          readMozaikState: function() {
              var mozaikState = localStorage.getItem(this.mozaik_id + "-state");
              if(mozaikState != null) {
                  mozaikState = JSON.parse(mozaikState);
                  //load saved values from localStorage
                  if(typeof(mozaikState.selected_terms_in_main_filter) !== 'undefined') {
                      this.selected_terms_in_main_filter = mozaikState.selected_terms_in_main_filter;
                  }

                  if(typeof(mozaikState.selected_terms_in_secondary_filter) !== 'undefined') {
                      this.selected_terms_in_secondary_filter = mozaikState.selected_terms_in_secondary_filter;
                  }
              }

          },

      },

  });

  return app;
}

function empty(value) {
  if (typeof(value) === 'undefined' || value === "" || value === null) return true;
  return false;
}


function arrayHasTerm(termArray, term) {
  if (typeof(termArray) === 'undefined' || typeof(term) === 'undefined') return false;
  for (var i=0; i < termArray.length; i++) {
    if (typeof(termArray[i]) === 'undefined' || typeof(term) === 'undefined' ) continue;
    if (termArray[i].term_id === term.term_id) return true;
  }
  return false;
}
